import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://musique-prete.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Obtenir le pack Musique Prête',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-2 rounded-full bg-tangerine px-7 py-[18px] text-center text-[15px] font-bold uppercase leading-tight tracking-[0.04em] text-white shadow-cta transition-all duration-200 hover:-translate-y-0.5 hover:bg-tangerine-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-tangerine/40 sm:gap-3 sm:px-10 sm:py-5 sm:text-base sm:tracking-[0.05em] ${className}`} data-id="element-44" data-mp="qk21j7bspmfj">
      <span aria-hidden="true" data-id="element-45" data-mp="157n5t4keprp1">📥</span>
      <span data-id="element-46" data-mp="35xxtet0zetuc">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-47" data-mp="35yqpn02be0y8" />
    </a>;
}